module.exports = __webpack_public_path__ + "log-in/img/access-code-see-stacked-examples.6c5b713e.png";